<template>
  <div class="position">
    <router-link to="/home">
        <img class="icon" src="../../assets/shouye.png" alt="">
    </router-link>
  </div>
</template>

<script>
export default {
  data () {
    return {
      home: '',
    }
  },
  created(){
  },
  methods:{
    toHome(){
      window.location.href=window.location.href.split('#')[0]+'#/home'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .position{
        position: absolute;;
        color:#ccc;
        top: 10px;
        left: 12px;
        z-index:9999;
    }
    .position .icon{
        width:44px;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/backHome.vue